type Props = {
  checked: boolean
  disabled?: boolean
  onChange: (next: boolean) => void
  label?: string
}

// Accessible checkbox-based switch. Pure CSS (.switch in styles.css).
export function Toggle({ checked, disabled, onChange, label }: Props) {
  return (
    <label className={`switch ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={label}
      />
      <span className="knob" aria-hidden />
    </label>
  )
}
